import { render, staticRenderFns } from "./getWayScene.vue?vue&type=template&id=07dc5168&scoped=true&"
import script from "./getWayScene.vue?vue&type=script&lang=js&"
export * from "./getWayScene.vue?vue&type=script&lang=js&"
import style0 from "./getWayScene.vue?vue&type=style&index=0&id=07dc5168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc5168",
  null
  
)

export default component.exports